<template lang="pug">
	.alert-area(class="alertBorderLeftError")
		.alert-wrap
			i(class="fa fa-exclamation-triangle alert-icon error" aria-hidden="true")
			slot
</template>

<script>
export default {
	name: 'area-alert'
}
</script>

<style lang="less">
	// css/components/alert-area.less
</style>



// WEBPACK FOOTER //
// src/app/project-audit/alert-area.vue